function p(e) {
  return e.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
}
export { p as escapeRegExp };